import { useStyletron } from "baseui";
import { OverviewPanelWrapper } from "../../../components/OverviewPanelWrapper"
import Heatmap from "./Heatmap";
import { SlEnergy } from "react-icons/sl";
import { TimeRange, startEndDateFromTimeRange } from "../../../../utils/timeUtils";
import { FormattedMessage } from "react-intl";

export const OverviewPanel = (props: any) => {
    const [css, theme] = useStyletron();
    const range = props.timeRange ?? TimeRange.Last12Months;
    const { start, end  } = startEndDateFromTimeRange(range);
    return (
        <OverviewPanelWrapper {...props}
        description={<FormattedMessage id="BuildingsCompare.EnergyHeatmap" defaultMessage="Energy Heatmap" />}
         icon={<SlEnergy  size='100%' color={theme.colors.backgroundPrimary}></SlEnergy>}   name={
            <>
            <FormattedMessage id={TimeRange[range]} defaultMessage={TimeRange[range]} /> | MWh
            </>
        }>
            <Heatmap valueFactor={0.001} dimension={'MWh'} {...props} start={start} end={end}></Heatmap>
        </OverviewPanelWrapper>
    )
}